import { useCallback, useEffect, useState } from "react";
import { IPortalDocument } from "../../../types/Documents";
import PortalDocuments from "../../../services/accounts/portalDocuments";
import { NavigateFunction, useNavigate } from "react-router-dom";

export const useFetchData = (accountId: string | undefined) => {
  const [data, setData] = useState<IPortalDocument[]>([]);

  const navigate: NavigateFunction = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = useCallback(async () => {
    try {
      if (accountId) {
        const res: IPortalDocument[] =
          await PortalDocuments.fetchAll(accountId);

        setData(res);

        setIsLoading(false);
      }
    } catch (e: any) {
      (e.status === 404 || e.status === 400) && navigate("/not-found");

      setIsLoading(false);
    }
  }, [accountId, navigate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading };
};
